<div class="px-4 sm:px-8 py-6 max-w-2xl mx-auto">

  <!-- Título -->
  <h1 class="text-2xl font-bold text-gray-800 text-center flex items-center justify-center" style="margin-bottom: 24px;">
    <mat-icon style="color: #1C593D; margin-right: 8px; flex-shrink: 0;">currency_bitcoin</mat-icon>
    Enviar Criptomonedas
  </h1>

  <!-- Tipo de cambio -->
  <app-usdt-change [usdt_clp_tax]="usdt_clp_tax"></app-usdt-change>

  <!-- Saldos -->
  <div class="flex flex-col xl:flex-row items-stretch justify-center gap-4" style="margin-top: 20px;">

    <!-- Saldo Actual -->
    <div style="flex: 1; background: white; border-radius: 14px; border: 1px solid #e5e7eb; padding: 20px; text-align: center; box-shadow: 0 1px 4px rgba(0,0,0,0.05);">
      <div style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #f0fdf4; border-radius: 10px; margin-bottom: 10px;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D; flex-shrink: 0;">account_balance_wallet</mat-icon>
      </div>
      <p style="font-size: 0.82rem; font-weight: 600; color: #6b7280; font-style: italic; margin: 0 0 6px;">Saldo Actual</p>
      <h2 *ngIf="hasLoaded" style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        ${{ saldoActual | currency:'':'' }}
        <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">CLP</span>
      </h2>
      <img *ngIf="!hasLoaded" src="assets/loader.svg" height="50" width="50" style="margin: 0 auto;" alt="Cargando">
    </div>

    <!-- Saldo Contable -->
    <div *ngIf="lineaCredito! > 0 && !lineaCreditoBloqueada"
      style="flex: 1; background: white; border-radius: 14px; border: 1px solid #e5e7eb; padding: 20px; text-align: center; box-shadow: 0 1px 4px rgba(0,0,0,0.05);">
      <div style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #eff6ff; border-radius: 10px; margin-bottom: 10px;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #2563eb; flex-shrink: 0;">savings</mat-icon>
      </div>
      <p style="font-size: 0.82rem; font-weight: 600; color: #6b7280; font-style: italic; margin: 0 0 6px;">Saldo Contable</p>
      <h2 *ngIf="hasLoaded" style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        ${{ saldoContable | currency:'':'' }}
        <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">CLP</span>
      </h2>
      <img *ngIf="!hasLoaded" src="assets/loader.svg" height="50" width="50" style="margin: 0 auto;" alt="Cargando">
    </div>

    <!-- Sobregiro Disponible -->
    <div *ngIf="lineaCredito! > 0 && !lineaCreditoBloqueada"
      style="flex: 1; background: white; border-radius: 14px; border: 1px solid #e5e7eb; padding: 20px; text-align: center; box-shadow: 0 1px 4px rgba(0,0,0,0.05);">
      <div style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #fef3c7; border-radius: 10px; margin-bottom: 10px;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #f59e0b; flex-shrink: 0;">trending_up</mat-icon>
      </div>
      <p style="font-size: 0.82rem; font-weight: 600; color: #6b7280; font-style: italic; margin: 0 0 6px;">Sobregiro Disponible</p>
      <h2 *ngIf="hasLoaded" style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        ${{ sobregiroDisponible | currency:'':'' }}
        <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">CLP</span>
      </h2>
      <img *ngIf="!hasLoaded" src="assets/loader.svg" height="50" width="50" style="margin: 0 auto;" alt="Cargando">
    </div>

  </div>

  <!-- Alerta línea bloqueada -->
  <div *ngIf="lineaCreditoBloqueada"
    style="margin-top: 16px; display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef2f2; padding: 10px 16px; border-radius: 10px; border: 1px solid #fecaca;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626; flex-shrink: 0;">warning</mat-icon>
    <span style="font-size: 0.82rem; font-weight: 600; color: #991b1b;">Su línea de crédito se encuentra actualmente bloqueada</span>
  </div>

  <!-- Botones de acción -->
  <div class="flex flex-col sm:flex-row justify-center gap-4" style="margin-top: 28px;">
    <button type="button" routerLink="/wallet/client/rechargeAccount"
      style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: #1C593D; color: white; border: none; border-radius: 12px; font-weight: 700; font-size: 1rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <img src="assets/flags/chile.png" alt="CLP" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
      Recargar Saldo
    </button>
    <button type="button" routerLink="/wallet/client/send-cripto"
      style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: #1C593D; color: white; border: none; border-radius: 12px; font-weight: 700; font-size: 1rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
      Comprar Criptomoneda
    </button>
  </div>

</div>
